import * as React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  // border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    // borderBottom: 0,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ExpandMoreIcon sx={{ fontSize: "1.3rem", color: "#2B817B" }} />
    }
    {...props}
  />
))(({ theme }) => ({
  padding: "5px 10px",
  borderRadius: "4px",
  backgroundColor:
    theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "#F6F6F6",
  flexDirection: "row",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
    color: "#2B817B",
  },
  "& .MuiAccordionSummary-content p": {
    marginLeft: theme.spacing(1),
    fontSize: "18px",
    fontWeight: "600",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "#F6F6F6",
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const NestedAccordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  // border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    // borderBottom: 0,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  "&:before": {
    display: "none",
  },
}));

const NestedAccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ExpandMoreIcon sx={{ fontSize: "1.3rem", color: "#545359" }} />
    }
    {...props}
  />
))(({ theme }) => ({
  padding: "5px 10px",
  borderRadius: "4px",
  backgroundColor:
    theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "#F6F6F6",
  flexDirection: "row",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
    color: "#545359",
  },
  "& .MuiAccordionSummary-content p": {
    marginLeft: theme.spacing(1),
    fontSize: "18px",
    fontWeight: "600",
  },
}));

const NestedAccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "#F6F6F6",
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const CustomAccordion = ({ nested = true, data }) => {
  const [expanded, setExpanded] = React.useState("panel1");

  return (
    <>
      {data &&
        data.map((item, index) => (
          <Accordion key={index} sx={{ my: 1 }}>
            <AccordionSummary key={index}>
              <Box
                width="100%"
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                <HelpOutlineIcon sx={{ mr: "20px" }} />
                <Typography>{item?.title}</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails key={index}>
              {nested === true && item?.children ? (
                item?.children.map((childItem, chidlIndex) => (
                  <NestedAccordion key={chidlIndex}>
                    <NestedAccordionSummary key={chidlIndex}>
                      <Box
                        width="100%"
                        display="flex"
                        justifyContent="flex-start"
                        alignItems="center"
                      >
                        <HelpOutlineIcon sx={{ mr: "20px" }} />
                        <Typography>{childItem?.title}</Typography>
                      </Box>
                    </NestedAccordionSummary>
                    <NestedAccordionDetails key={chidlIndex}>
                      <Typography>{childItem?.desp}</Typography>
                    </NestedAccordionDetails>
                  </NestedAccordion>
                ))
              ) : (
                <Typography>{item?.desp}</Typography>
              )}
            </AccordionDetails>
          </Accordion>
        ))}
    </>
  );
};

export default CustomAccordion;
